import { render, staticRenderFns } from "./NewHealthServices.vue?vue&type=template&id=056aa609&scoped=true&"
import script from "./NewHealthServices.vue?vue&type=script&lang=js&"
export * from "./NewHealthServices.vue?vue&type=script&lang=js&"
import style0 from "./NewHealthServices.vue?vue&type=style&index=0&id=056aa609&scoped=true&lang=css&"
import style1 from "./NewHealthServices.vue?vue&type=style&index=1&id=056aa609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056aa609",
  null
  
)

export default component.exports